import get from 'lodash/get';

import { SurveyInitialState, SurveyItemWithType } from '@r1-frontend/survey/context/reducer/initialState';
import { SurveyName, SurveyType } from '@r1-frontend/survey/context/surveys';

export interface SurveyDialogProperties {
    type: SurveyType,
    name?: SurveyName,
}

export interface SurveyDialogDetails {
    isOpen: boolean,

    name: string,
    type: SurveyType,
    activeTo?: Date,

    image: string,
    title: string,
    description: string,
    buttonText: string,
    externalLink?: string,
}

const getDialogDetails = (state: SurveyInitialState): SurveyDialogDetails | undefined => {
    const { survey, _toShow: { type, name, inPopup = true } } = state;

    let currentSurvey: SurveyItemWithType | undefined = undefined;

    const byType = survey.filter(srv => srv.type === type);

    if (byType.length) {
        if (name) {
            currentSurvey = byType.find(srv => srv.name === name);
        } else {
            currentSurvey = byType[0];
        }
    }

    if (!currentSurvey) {
        return;
    }

    return {
        isOpen: inPopup,

        name: currentSurvey.name,
        type: currentSurvey.type,
        activeTo: currentSurvey.active?.to,

        image: currentSurvey.image || `${require('@static/images/survey/bubble.png')}`,
        title: get(currentSurvey, 'title', 'Оцените качество работы сайта'),
        description: get(currentSurvey, 'description', 'Пройдите короткий опрос, чтобы сделать наш сайт лучше'),
        buttonText: currentSurvey.buttonText || 'Пройти опрос',
        externalLink: get(currentSurvey, 'externalLink'),
    };
};

export default getDialogDetails;
